/**
 * Created by: cparaschiv
 * Date: 20.05.2013, 17:39
 */

(function(){
    'use strict';

    var GridDataSource = kendo.data.DataSource.extend({

        Extends: kendo.data.DataSource,

        isLoaded: false,
        _observableCollection: null,

        init: function(options) {
            var me = this,
                transportCfg,
                t, defaults;

            transportCfg = options.transport;
            transportCfg.data = options.data;

            t = new TS.GridTransport(transportCfg);

            options.transport = t;
            options.autoSync = true;

            kendo.data.DataSource.fn.init.call(me, options);
        },

        setData: function(observableCollection) {
            var me = this;

            me._observableCollection = observableCollection;
            me.transport.setData(observableCollection);

            me.data(me.transport.data);
        },

        fetch: function(callback) {
            var that = this;
            if (callback && isFunction(callback)) {
                that.one(CHANGE, callback);
            }
            that._query();
        }

    });

    TS.GridDataSource = GridDataSource;

})();
